module.exports = __webpack_public_path__ + "static/media/bomba.798c96f4.svg";